import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

import 'mburger-webcomponent'
import "mmenu-js";

// Animations
import anime from 'animejs/lib/anime.es.js';

Alpine.directive('uppercase', el => {
    el.textContent = el.textContent.toUpperCase()
})

window.hideChildren = function hideChildren(element) {
  const children = element.children;
  for (let i = 0; i < children.length; i++) {
    children[i].style.opacity = 0;
  }
}

window.fadeInStagger = function fadeInStagger(el) {
          anime({
          targets: el,
          opacity: [0, 1],
          translateY: [25, 0],
          duration: 1000,
          easing: 'easeInOutExpo',
          delay: anime.stagger(250, {start: 250}) , // Stagger the delay
        });
}
Alpine.plugin(intersect)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
Alpine.start()